export default function firstNotEmptyArray(...arrays) {
    for (const arr of arrays) {
        if (arr.length > 0)
            return arr;
    }
    return [];
}
